import React, {useContext,useReducer,useEffect} from 'react'
import {audioFile} from './data.js'
import {myreducer} from '../src/reducer/reducer'



const AppContext = React.createContext()

const getdeviceStroage = () =>{
    let mobile = localStorage.getItem('mobile')
    if(mobile){
        return JSON.parse(localStorage.getItem('mobile'))
    }else{
        return []
    }
}

const getCartStorage = () =>{
    let cart = localStorage.getItem('cart')
    if(cart){
        return JSON.parse(localStorage.getItem('cart'))
    }else{
        return []
    }
}




const initialState  = {
    devices:audioFile,
    cart:getCartStorage(),
    amount:0
}


const Context = ({children}) => {
    const [state,dispatch] = useReducer(myreducer,initialState)
    const [devices2,setDevices] = React.useState(audioFile)
    console.log(devices2);
    console.log(state.devices);

    const addToCart = (id) =>{
        dispatch({type:'ITEM_ADDED_H',payload:id})
    }
    // const addToCartS = (id) =>{
    //     dispatch({type:'ITEM_ADDED_S',payload:id})
    // }

    const increaseCount = (id) => {
        dispatch({type:"++_COUNT",payload:id})
    }
    

    const decreaseCount = (id) => {
        dispatch({type:"--_COUNT",payload:id})
    }

    const clearCart = () =>{
        dispatch({type:"CLEAR_CART"})
    }

    useEffect(()=>{
        localStorage.setItem("mobile",JSON.stringify(state.devices))
    },[state.devices,state.cart,devices2])

    useEffect(()=>{
        localStorage.setItem('cart',JSON.stringify(state.cart))
    },[state.cart])

    useEffect(()=>{
        dispatch({type:"GET_TOTALS"})
        // console.log(state.cart);
    },[state.cart])
    
    return (
        <AppContext.Provider value={{...state,addToCart,increaseCount,decreaseCount,clearCart,devices2}}>
            {children}
        </AppContext.Provider>
    )
}

export const useGlobalContext = () =>{
    return useContext(AppContext)
}

export {AppContext,Context}
